export const lokalforeningTemplate1 = [
  {
    text: "Foreningens navn",
    name: "foreningsNavn",
  },
  {
    text: "Organisasjonsnummer",
    name: "organisasjonsNummer",
    type: "number",
  },
  {
    text: "Fylke",
    name: "fylke",
  },
  {
    text: "Kommune",
    name: "kommune",
  },
];

export const lokalforeningTemplate2 = [
  {
    text: "Lokalforeningens kontonummer",
    name: "kontoNummer",
    type: "number",
  },
  {
    text: "Lokalforeningens e-post",
    name: "epost",
  },
  {
    text: "Facebook-referanse",
    name: "facebookReferanse",
  },
  {
    text: "Web-adresse",
    name: "webAdresse",
  },
];

export const medlemsinformasjonTemplate = [
  {
    text: "Medlemmer",
    name: "antallMedlemmer",
  },
  {
    text: "Betalende medlemmer",
    name: "antallBetalendeMedlemmer",
  },
  {
    text: "Nye medlemmer siste år",
    name: "antallNyeMedlemmerSisteAr",
  },
  {
    text: "Utmeldte medlemmer siste år",
    name: "antallUtmeldteMedlemmerSisteAr",
  },
  {
    text: "Gjennomsnittsalder",
    name: "gjennomsnittsAlder",
  },
];
